export default __webpack_public_path__ + "static/media/khanbrothers.a92a3f74.png";